import React, { useState } from "react";
import { Form, Button, Alert, Container } from "react-bootstrap";
import emailjs from "emailjs-com";
import styles from "./ContactForm.module.css";

export const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [status, setStatus] = useState({ success: false, error: false, loading: false });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus({ success: false, error: false, loading: true });

    if (formData.name && formData.email && formData.message) {
      const dataToSend = {
        from_name: formData.name,
        from_email: formData.email,
        message: formData.message,
      };

      emailjs
        .send(
          process.env.REACT_APP_EMAILJS_SERVICE_ID,
          process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
          dataToSend,
          process.env.REACT_APP_EMAILJS_PUBLIC_KEY
        )
        .then((response) => {
          setStatus({ success: true, error: false, loading: false });
          setFormData({ name: "", email: "", message: "" });
          setTimeout(() => {
            setStatus((prev) => ({ ...prev, success: false }));
          }, 6000);
        })
        .catch((err) => {
          console.error("Email send error:", err);
          setStatus({ success: false, error: true, loading: false });
          setTimeout(() => {
            setStatus((prev) => ({ ...prev, error: false }));
          }, 6000);
        });
    } else {
      setStatus({ success: false, error: true, loading: false });
      setTimeout(() => {
        setStatus((prev) => ({ ...prev, error: false }));
      }, 6000);
    }
  };

  return (
    <div className={styles.container} data-aos="fade-up" id="contact">
      <Container className="py-5" style={{ maxWidth: "600px" }}>
        <h2 className={styles.title}>Contact Us</h2>

        {status.success && (
          <Alert className={`${styles.alert} ${styles.alertSuccess}`}>
            Your message has been sent successfully!
          </Alert>
        )}
        {status.error && (
          <Alert className={`${styles.alert} ${styles.alertError}`}>
            Failed to send your message. Please try again.
          </Alert>
        )}
        {status.loading && (
          <Alert className={`${styles.alert} ${styles.alertLoading}`}>
            Sending your message...
          </Alert>
        )}

        <Form className={styles.form} onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label className={styles.label}>Name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter your name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className={styles.label}>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="Enter your email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label className={styles.label}>Message</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              placeholder="Write your message here"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
            />
          </Form.Group>

          <Button type="submit" className={styles.btn} disabled={status.loading}>
            {status.loading ? "Sending..." : "Send Message"}
          </Button>
        </Form>
      </Container>
    </div>
  );
};

export default ContactForm;
